const createGetProvinciasLocalidades =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk }) =>
  (provinciaId) => {
    let request = buildRequestWithAuth("GET");

    return fetch(
      `${environment.originacionUrl}/provincias/${encodeURI(
        provinciaId
      )}/localidades?format=json`,
      request
    )
      .then(errorUnlessOk)
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  };

const createGetProvinciasCodigosPostales =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk }) =>
  (provinciaId, localidad) => {
    let request = buildRequestWithAuth("GET");

    let url = `${environment.originacionUrl}/provincias/${encodeURI(
      provinciaId
    )}/codigospostales`;

    url = localidad ? `${url}?localidad=${encodeURI(localidad)}` : url;

    return fetch(url, request)
      .then(errorUnlessOk)
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  };

export {
  createGetProvinciasLocalidades,
  createGetProvinciasCodigosPostales
};
